import React, { useState, useEffect } from 'react';

import useLazyQuery from '../../../../../../surveys/hooks/useLazyQuery';

import isFilterChanged from '../../../../helpers/isFilterChanged';
import isAllowedToApplyFilter from '../../../../helpers/isAllowedToApplyFilter';
import getUserPropertiesMapping from '../../../../helpers/getUserPropertiesMapping';

import filterResultsButton from '../../../../../../campaigns/components/CampaignTable/CampaignFilters/assets/filter-results-button.svg';
import addButton from '../../../../../../assets/img/add.svg';

import { COMMUNITY_DASHBOARD_FILTER_TYPE } from '../../../../helpers/constants';

import { GET_APP_CONFIGURATION } from '../../../../../../graphql/Dashboard';

import ActiveFilters from './components/ActiveFilters/ActiveFilters';
import SingleFilter from './components/SingleFilter/SingleFilter';
import Loader from '../Loader/Loader';

import styles from './Filters.module.css';

export default ({
  appliedFilters,
  setAppliedFilters,
  filterRelation,
  setFilterRelation,
  isGlobalLoading
}) => {
  const [showFiltersContainer, setShowFiltersContainer] = useState(false);
  const [innerAppliedFilters, setInnerAppliedFilters] = useState([]);
  const [innerFilterRelation, setInnerFilterRelation] = useState(null);

  const [userPropertiesMapping, setUserPropertiesMapping] = useState(null);

  const getAppConfiguration = useLazyQuery(GET_APP_CONFIGURATION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(
    () => {
      setInnerAppliedFilters(JSON.parse(JSON.stringify(appliedFilters)));
      setInnerFilterRelation(filterRelation);
    },
    [appliedFilters]
  );

  useEffect(
    () => {
      const innerGetAppConfiguration = async () => {
        if (showFiltersContainer && !userPropertiesMapping) {
          const loadedAppConfiguration = await getAppConfiguration({});
          const processedUserPropertiesMapping = getUserPropertiesMapping(
            loadedAppConfiguration
          );

          setUserPropertiesMapping(processedUserPropertiesMapping);
        }
      };

      innerGetAppConfiguration();
    },
    [showFiltersContainer]
  );

  const isConfigurationDataReady = userPropertiesMapping;

  const isCurrentFilterChanged = isFilterChanged(
    innerAppliedFilters,
    appliedFilters
  );
  const isAllowedToApplyCurrentFilter = isAllowedToApplyFilter(
    innerAppliedFilters,
    appliedFilters
  );

  const isApplyButtonAllowed = isAllowedToApplyCurrentFilter;

  return (
    <div
      className={
        isGlobalLoading
          ? `${styles.container} ${styles.transparent}`
          : styles.container
      }
    >
      <div className={styles.filtersButtonContainer}>
        <div
          role="presentation"
          className={
            showFiltersContainer
              ? `${styles.filtersButton} ${styles.filtersButtonActive}`
              : styles.filtersButton
          }
          onClick={() => {
            if (!isCurrentFilterChanged && !isGlobalLoading) {
              setShowFiltersContainer(!showFiltersContainer);
            }
          }}
        >
          <img src={filterResultsButton} alt="Filter result icon" />
          Filters
        </div>
      </div>
      {showFiltersContainer ? (
        <div className={styles.filtersContainer}>
          {isConfigurationDataReady ? (
            <>
              <div>
                {innerAppliedFilters.map((singleFilter, singleFilterIndex) => (
                  <SingleFilter
                    key={`single-filter-${singleFilterIndex.toString()}`}
                    singleFilterIndex={singleFilterIndex}
                    appliedFilters={innerAppliedFilters}
                    setAppliedFilters={setInnerAppliedFilters}
                    filterRelation={innerFilterRelation}
                    setFilterRelation={setInnerFilterRelation}
                    userPropertiesMapping={userPropertiesMapping}
                  />
                ))}
              </div>
              <div className={styles.footer}>
                <div
                  role="presentation"
                  className={styles.addFilterButton}
                  onClick={() => {
                    const newInnerAppliedFilters = [...innerAppliedFilters];
                    newInnerAppliedFilters.push({
                      type: COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG,
                      tags: {}
                    });
                    setInnerAppliedFilters(newInnerAppliedFilters);
                  }}
                >
                  <img src={addButton} alt="add filter button" />
                  Add Filter
                </div>
                <div className={styles.filterControlsContainer}>
                  <div
                    role="presentation"
                    className={styles.whiteButton}
                    onClick={() => {
                      setInnerAppliedFilters(appliedFilters);
                      setFilterRelation(filterRelation);
                      setShowFiltersContainer(false);
                    }}
                  >
                    Cancel
                  </div>
                  <div
                    role="presentation"
                    className={
                      isApplyButtonAllowed
                        ? styles.purpleButton
                        : styles.buttonDisabled
                    }
                    onClick={() => {
                      if (isApplyButtonAllowed) {
                        setAppliedFilters([...innerAppliedFilters]);
                        setFilterRelation(innerFilterRelation);
                        setShowFiltersContainer(false);
                      }
                    }}
                  >
                    Apply filters
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div>
              <Loader fixed={false} />
            </div>
          )}
        </div>
      ) : (
        <ActiveFilters
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          isGlobalLoading={isGlobalLoading}
        />
      )}
    </div>
  );
};
